import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import { DataQuerySingleValueField } from '../../../../_common/application/tsx/DataQuerySingleValueField';
import { ChartFunctionsWrapper, FontWrapper, NotificationCallWrapper } from '../DashboardWidget_dxChart_Parametrized';
import { themeFields } from '../themes/themeFields';

export class StripsWrapper {
    //LL: when useDataQuerySingleValueField: true,
    public static produceDataQueryArray(Strips) {
        let dqa = [];
        
        _.each(Strips, function (obj: any, index) {
            if (obj.fromDataSourceStart === true) {
                if (DataQuerySingleValueField.validateQuery(obj.dataQueryStart)) {
                    let title = 'Strip_Start_' + index;

                    obj.valueDataSourceTitleStart = title;

                    //  validated obj.dataQuery is array[1]
                    let queryStart = obj.dataQueryStart[0];
                    let queryStart2 = $.extend(true, { title: title }, queryStart);
                    dqa.push(queryStart2);
                }
            }
            if (obj.fromDataSourceEnd === true) {
                if (DataQuerySingleValueField.validateQuery(obj.dataQueryEnd)) {
                    let title = 'Strip_End_' + index;

                    obj.valueDataSourceTitleEnd = title;

                    //  validated obj.dataQuery is array[1]
                    let queryEnd = obj.dataQueryEnd[0];
                    let queryEnd2 = $.extend(true, { title: title }, queryEnd);
                    dqa.push(queryEnd2);
                }
            }
        });
        return dqa;
    }

    private wParams: any = {};

    constructor(_wParams) {
        this.wParams = _wParams;
    }

    public createStripCommonStyle(_theme) {
        let stripCommonStyle: any = {
            color: this.wParams.axisStrips.colorDefault,
            label: {
                font: { color: this.wParams.axisStrips.labelFontColorDefault },
                verticalAlignment: this.wParams.axisStrips.labelVerticalAlignmentDefault,
                horizontalAlignment: this.wParams.axisStrips.labelHorizontalAlignmentDefault
            }
        };

        let fo = FontWrapper.createFontObj_fromTheme(this.wParams, _theme, themeFields.font_inStrips);
        if (fo != null) {
            let foKeys = _.keys(fo);
            if (foKeys.length > 0) {
                if (stripCommonStyle.label.font == null) {
                    stripCommonStyle.label.font = {};
                }
                _.extend(stripCommonStyle.label.font, fo); // shallow
            }
        }

        return stripCommonStyle;
    }

    public static compareDataTypes(axisDataType, valueDataType) {
        let wrong = false;

        if (axisDataType === 'i') {
            if (!(valueDataType === 'i' || valueDataType === 'r')) {
                wrong = true;
            }
        } else if (axisDataType === 'r') {
            if (!(valueDataType === 'i' || valueDataType === 'r')) {
                wrong = true;
            }
        } else if (axisDataType === 'date' || axisDataType === 'datetime') {
            if (!(valueDataType === 'date' || valueDataType === 'datetime')) {
                wrong = true;
            }
        } else if (axisDataType === 'time') {
            if (valueDataType !== 'time') {
                wrong = true;
            }
        } else if (axisDataType === 'b') {
            if (valueDataType !== 'b') {
                wrong = true;
            }
        }

        return wrong;
    }

    public static convertToDateTime(axisDataType, value) {
        //LL: presume isTypeOfAnyDate is already checked
        let dateValue: any = null;

        if (DateTimeFunctions.isTypeOfDateOrDatetime(axisDataType)) {
            let aDate: any = new Date(value);

            if (!isNaN(aDate)) {
                dateValue = aDate;
            }
        } else if (DateTimeFunctions.isTypeOfTime(axisDataType)) {
            const defDate = DateTimeFunctions.TimeDefaultDate;
            let sDate =
                defDate.year.toString() + '-' + defDate.month.toString() + '-' + defDate.day.toString() + ' ' + value;
            let aDate: any = new Date(sDate);
            if (!isNaN(aDate)) {
                dateValue = aDate;
            }
        }

        return dateValue;
    }

    public createStrips(argType, yType, dataOneDim, glob: IGlob) {
        let stripsX = [];
        let stripsY = [];
        let stripsA = {}; // each: { key: AUX1, { strips: [], canAsPercent: , hasAsPercent: , wrongAsPercent: }

        let strips_canAsPercentX = false;
        let strips_canAsPercentY = false;
        strips_canAsPercentX = ChartFunctionsWrapper.evalCanAsPercent_ForArgumentAxis(this.wParams, argType);
        strips_canAsPercentY = ChartFunctionsWrapper.evalCanAsPercent_ForValueAxis(this.wParams, yType);

        let strips_hasAsPercentX = false; // also used external
        let strips_hasAsPercentY = false; // also used external
        let strips_hasAsPercentA = false; // also used external
        let strips_wrongAsPercentX = false;
        let strips_wrongAsPercentY = false;
        let strips_wrongAsPercentA = false;

        let strips_wrongDataTypeX = false;
        let strips_wrongDataTypeY = false;
        let strips_wrongDataTypeA = false;

        for (let i = 0; i < this.wParams.axisStrips.strips.length; i++) {
            let stripDef = this.wParams.axisStrips.strips[i];

            let valStart: any = stripDef.startValue;
            let dataTypeStart = null; //  was not before
            if (stripDef.fromDataSourceStart === true) {
                if (stripDef.valueDataSourceTitleStart == null) {
                    //  warning ?
                    continue;
                }
                if (dataOneDim == null || dataOneDim[stripDef.valueDataSourceTitleStart] == null) {
                    //  warning ?
                    continue;
                }
                valStart = dataOneDim[stripDef.valueDataSourceTitleStart].value;
                if (valStart == null) {
                    continue;
                }
                dataTypeStart = dataOneDim[stripDef.valueDataSourceTitleStart].type;
            }

            let valEnd: any = stripDef.endValue;
            let dataTypeEnd = null; //  was not before
            if (stripDef.fromDataSourceEnd === true) {
                if (stripDef.valueDataSourceTitleEnd == null) {
                    //  warning ?
                    continue;
                }
                if (dataOneDim == null || dataOneDim[stripDef.valueDataSourceTitleEnd] == null) {
                    //  warning ?
                    continue;
                }
                valEnd = dataOneDim[stripDef.valueDataSourceTitleEnd].value;
                if (valEnd == null) {
                    continue;
                }
                dataTypeEnd = dataOneDim[stripDef.valueDataSourceTitleEnd].type;
            }

            let labelText = stripDef.label;
            //LL: decided not to do it:
            //if (labelText == null || labelText.trim() === '') {
            //    let dsStart = '';
            //    if (stripDef.fromDataSourceStart === true) {
            //        dsStart = stripDef.valueDataSourceTitleStart;
            //    }
            //    let dsEnd = '';
            //    if (stripDef.fromDataSourceEnd === true) {
            //        dsEnd = stripDef.valueDataSourceTitleEnd;
            //    }
            //    labelText = dsStart + " " + dsEnd;
            //}

            let strip: any = {
                startValue: valStart,
                endValue: valEnd,
                asPercentLL: false,
                color: stripDef.color != null ? stripDef.color : this.wParams.axisStrips.colorDefault,
                //LL: 27.11.17: added as a workaround of DevExpr bug:  (some value must be set)
                paddingTopBottom: 0, //LL: otherwise "top" label is not shown for vert line when no Title (no space above Chart !)
                paddingLeftRight: 0, //LL: otherwise "outside" label is not shown for horiz line on the opposite side of axis (no space above Chart !)
                label: {
                    font: {
                        color:
                            stripDef.fontColor != null
                                ? stripDef.fontColor
                                : this.wParams.axisStrips.labelFontColorDefault
                    },
                    text: labelText,
                    verticalAlignment: 'center',
                    horizontalAlignment: 'center'
                }
            };

            if (stripDef.type === 'values') {
                strip.label.horizontalAlignment = stripDef.labelHorizontalAlignment;
                strip.label.verticalAlignment = stripDef.labelVerticalAlignment;

                if (strips_canAsPercentY && stripDef.asPercent != null) {
                    strip.asPercentLL = stripDef.asPercent;
                    if (strip.asPercentLL === true) {
                        strips_hasAsPercentY = true;
                    }
                }
                let wrong = false;
                if (!strips_canAsPercentY && stripDef.asPercent === true) {
                    strips_wrongAsPercentY = true;
                    wrong = true;
                }

                if (!wrong && dataTypeStart != null) {
                    let wrongDataTypeY = StripsWrapper.compareDataTypes(yType, dataTypeStart);
                    if (wrongDataTypeY) {
                        wrong = true;
                    }
                    strips_wrongDataTypeY = strips_wrongDataTypeY || wrongDataTypeY;
                    if (wrong) {
                        console.log(
                            'Strip values: wrong data type: yType = ' + yType + ' dataTypeStart = ' + dataTypeStart
                        );
                    }
                }
                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(yType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(yType, valStart);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            strip.startValue = aDate;
                        }
                    }

                    if (wrong) {
                        console.log('Strip values: wrong data type: yType = ' + yType + ' start value = ' + valStart);
                    }
                }

                if (!wrong && dataTypeEnd != null) {
                    let wrongDataTypeY = StripsWrapper.compareDataTypes(yType, dataTypeEnd);

                    if (wrongDataTypeY) {
                        wrong = true;
                    }

                    strips_wrongDataTypeY = strips_wrongDataTypeY || wrongDataTypeY;

                    if (wrong) {
                        console.log(
                            'Strip values: wrong data type: yType = ' + yType + ' dataTypeEnd = ' + dataTypeEnd
                        );
                    }
                }
                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(yType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(yType, valEnd);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            strip.endValue = aDate;
                        }
                    }
                    if (wrong) {
                        console.log('Strip values: wrong data type: yType = ' + yType + ' end value = ' + valEnd);
                    }
                }

                if (!wrong) {
                    stripsY.push(strip);
                }
            } else if (stripDef.type === 'arguments') {
                strip.label.horizontalAlignment = stripDef.labelHorizontalAlignment;
                strip.label.verticalAlignment = stripDef.labelVerticalAlignment;

                if (strips_canAsPercentX && stripDef.asPercent != null) {
                    strip.asPercentLL = stripDef.asPercent;

                    if (strip.asPercentLL === true) {
                        strips_hasAsPercentX = true;
                    }
                }

                let wrong = false;

                if (!strips_canAsPercentX && stripDef.asPercent === true) {
                    strips_wrongAsPercentX = true;
                    wrong = true;
                }

                if (!wrong && dataTypeStart != null) {
                    let wrongDataTypeX = StripsWrapper.compareDataTypes(argType, dataTypeStart);

                    if (wrongDataTypeX) {
                        wrong = true;
                    }

                    strips_wrongDataTypeX = strips_wrongDataTypeX || wrongDataTypeX;

                    if (wrong) {
                        console.log(
                            'Strip arguments: wrong data type: argType = ' +
                                argType +
                                ' dataTypeStart = ' +
                                dataTypeStart
                        );
                    }
                }
                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(argType)) {
                        let aDate = StripsWrapper.convertToDateTime(argType, valStart);

                        if (aDate == null) {
                            wrong = true;
                        } else {
                            strip.startValue = aDate;
                        }
                    }

                    if (wrong) {
                        console.log(
                            'Strip arguments: wrong data type: argType = ' + argType + ' start value = ' + valStart
                        );
                    }
                }

                if (!wrong && dataTypeEnd != null) {
                    let wrongDataTypeX = StripsWrapper.compareDataTypes(argType, dataTypeEnd);

                    if (wrongDataTypeX) {
                        wrong = true;
                    }

                    strips_wrongDataTypeX = strips_wrongDataTypeX || wrongDataTypeX;

                    if (wrong) {
                        console.log(
                            'Strip arguments: wrong data type: argType = ' + argType + ' dataTypeEnd = ' + dataTypeEnd
                        );
                    }
                }
                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(argType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(argType, valEnd);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            strip.endValue = aDate;
                        }
                    }
                    if (wrong) {
                        console.log(
                            'Strip arguments: wrong data type: argType = ' + argType + ' end value = ' + valEnd
                        );
                    }
                }

                if (!wrong) {
                    stripsX.push(strip);
                }
            } else {
                //  each in stripsA: { key: AUX1, { strips: [], canAsPercent: , hasAsPercent: , wrongAsPercent: }
                let axisName = stripDef.type;

                if (stripsA[axisName] == null) {
                    stripsA[axisName] = {
                        strips: [],
                        canAsPercent: false,
                        hasAsPercent: false,
                        wrongAsPercent: false
                    };

                    stripsA[axisName].canAsPercent = ChartFunctionsWrapper.evalCanAsPercent_ForAuxAxis(
                        this.wParams,
                        axisName,
                        glob
                    );

                    let oDataType = ChartFunctionsWrapper.evalAuxAxisType(this.wParams, axisName, glob); // return { yType: yType, yTimePart: yTimePart  }
                    let aaType = oDataType.yType;

                    if (oDataType.yTimePart != null) {
                        aaType = oDataType.yTimePart;
                    }

                    stripsA[axisName].dataType = aaType;
                }

                let canAsPercentA = stripsA[axisName].canAsPercent;
                let aType = stripsA[axisName].dataType;

                strip.label.horizontalAlignment = stripDef.labelHorizontalAlignment;
                strip.label.verticalAlignment = stripDef.labelVerticalAlignment;

                if (canAsPercentA && stripDef.asPercent != null) {
                    strip.asPercentLL = stripDef.asPercent;
                    if (strip.asPercentLL === true) {
                        stripsA[axisName].hasAsPercent = true;
                        strips_hasAsPercentA = true;
                    }
                }

                let wrong = false;

                if (!canAsPercentA && stripDef.asPercent === true) {
                    stripsA[axisName].wrongAsPercent = true;
                    strips_wrongAsPercentA = true;
                    wrong = true;
                }

                if (!wrong && dataTypeStart != null) {
                    let wrongDataTypeA = StripsWrapper.compareDataTypes(aType, dataTypeStart);
                    if (wrongDataTypeA) {
                        wrong = true;
                    }
                    strips_wrongDataTypeA = strips_wrongDataTypeA || wrongDataTypeA;
                    if (wrong) {
                        console.log(
                            'Strip AUX values: wrong data type: aType = ' + aType + ' dataTypeStart = ' + dataTypeStart
                        );
                    }
                }
                //LL: convert value to Date/Time if needed  for Start & End
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(aType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(aType, valStart);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            strip.startValue = aDate;
                        }
                    }
                    if (wrong) {
                        console.log(
                            'Strip AUX values: wrong data type: aType = ' + aType + ' start value = ' + valStart
                        );
                    }
                }

                if (!wrong && dataTypeEnd != null) {
                    let wrongDataTypeA = StripsWrapper.compareDataTypes(aType, dataTypeEnd);
                    if (wrongDataTypeA) {
                        wrong = true;
                    }
                    strips_wrongDataTypeA = strips_wrongDataTypeA || wrongDataTypeA;
                    if (wrong) {
                        console.log(
                            'Strip AUX values: wrong data type: aType = ' + aType + ' dataTypeEnd = ' + dataTypeEnd
                        );
                    }
                }
                //LL: convert value to Date/Time if needed  for Start & End
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(aType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(aType, valEnd);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            strip.endValue = aDate;
                        }
                    }
                    if (wrong) {
                        console.log('Strip AUX values: wrong data type: aType = ' + aType + ' end value = ' + valEnd);
                    }
                }

                if (!wrong) {
                    stripsA[axisName].strips.push(strip);
                }
            }
        }

        if (strips_wrongDataTypeX) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Strips for Argument Axis have wrong Data Type in Value Query.<br>' +
                    'Such Strips are not shown<br>',
                true
            );
        }
        if (strips_wrongDataTypeY) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Strips for Value Axis have wrong Data Type in Value Query.<br>' + 'Such Strips are not shown<br>',
                true
            );
        }
        if (strips_wrongDataTypeA) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Strips for AUX Value Axis have wrong Data Type in Value Query.<br>' +
                    'Such Strips are not shown<br>',
                true
            );
        }

        if (strips_wrongAsPercentX) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Strips for Argument Axis have "As Percent" option set, but Argument Axis is discrete or is of date-time type.<br>' +
                    'Such Strips are not shown<br>',
                true
            );
        }
        if (strips_wrongAsPercentY) {
            NotificationCallWrapper.notify(
                'warning',
                'Some Strips for Value Axis have "As Percent" option set, but Value Axis is discrete or is of date-time type.<br>' +
                    'Such Strips are not shown<br>',
                true
            );
        }
        if (strips_wrongAsPercentA) {
            NotificationCallWrapper.notify(
                'warning',
                'Some Strips for a Secondary Value Axis have "As Percent" option set, but this Secondary Value Axis is discrete or is of date-time type.<br>' +
                    'Such Strips are not shown<br>',
                true
            );
        }
        return {
            stripsX: stripsX,
            stripsY: stripsY,
            stripsA: stripsA, // each: { key: AUX1, { strips: [], canAsPercent: , hasAsPercent: , wrongAsPercent: }
            strips_hasAsPercentX: strips_hasAsPercentX,
            strips_hasAsPercentY: strips_hasAsPercentY,
            strips_hasAsPercentA: strips_hasAsPercentA
        };
    }

    public applyAsPercent(strips, max) {
        if (strips == null) {
            //LL: for AUX axis
            return;
        }
        for (let i = 0; i < strips.length; i++) {
            let strip: any = strips[i];
            if (strip.asPercentLL) {
                let val1 = strip.startValue;
                //LL: parseInt(str), parseFloat(str), Number(str)
                let num1 = Number(val1);
                if (!isNaN(num1)) {
                    val1 = num1;
                }
                strip.startValue = (val1 * max) / 100;

                let val2 = strip.endValue;
                //LL: parseInt(str), parseFloat(str), Number(str)
                let num2 = Number(val2);
                if (!isNaN(num2)) {
                    val2 = num2;
                }
                strip.endValue = (val2 * max) / 100;
            }
        }
    }
}
